import React from 'react';

import { css } from 'emotion';
import { BaseLabel, type BaseLabelProps } from './BaseLabel';

const iconStyle = css`
  margin-right: 5px;
`;

interface LabelProps extends BaseLabelProps {
  icon?: React.ReactElement<any>;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Label = (props: LabelProps) => {
  const { icon, children, ...otherProps } = props;

  if (!icon) {
    return <BaseLabel {...props} />;
  }

  const iconWithProps = React.cloneElement(icon, { className: iconStyle });

  return (
    <BaseLabel {...otherProps}>
      {iconWithProps}
      {children}
    </BaseLabel>
  );
};
